export default __webpack_public_path__ + "static/media/chevron_right.fd45a49e.svg";